import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { OperationKeys } from '@decaf-ts/db-decorators';
import { CrudFieldComponent, Dynamic, windowEventEmitter } from '@decaf-ts/for-angular';
import { ComponentEventNames } from '@decaf-ts/ui-decorators';
import { IonCheckbox, IonInput, IonItem, IonLabel, IonText } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { convertDateToGS1Format, getLastDayOfMonth } from '@pharmaledgerassoc/ptp-toolkit/shared';
import { timer } from 'rxjs';
import { formatExpiryDate } from 'src/app/handlers/BatchHandler';

@Dynamic()
@Component({
  selector: 'app-expiry-date-field',
  templateUrl: './expiry-date-field.component.html',
  styleUrls: ['./expiry-date-field.component.scss'],
  imports: [TranslatePipe, IonInput, IonCheckbox, IonItem, IonLabel, IonText, CommonModule],
  standalone: true,
})
export class AppExpiryDateFieldComponent extends CrudFieldComponent implements OnInit {
  @ViewChild('calendarInputElement', { read: ElementRef, static: false })
  calendarInputElement!: ElementRef<HTMLInputElement>;

  expiryDate?: string;

  @Input()
  enableDaySelection!: boolean;

  calendarInputValue?: string;

  override async ngOnInit(): Promise<void> {
    await super.initialize();

    if (this.operation === OperationKeys.CREATE) {
      this.enableDaySelection = true;
    }
    if (this.name === 'enableDaySelection' && this.enableDaySelection === true) {
      this.formGroup?.get(this.name)?.setValue(this.enableDaySelection);
      this.changeDetectorRef.detectChanges();
    }
  }

  handleChange(event: CustomEvent) {
    const { value, checked } = event.detail;
    windowEventEmitter(ComponentEventNames.Change, {
      source: this.name,
      value: this.type === this.HTML5InputTypes.CHECKBOX ? checked : value,
    });
  }

  @HostListener('window:ChangeEvent', ['$event'])
  override async handleEvent(event: CustomEvent): Promise<void> {
    const { source, value } = event.detail;
    if (source !== this.name) {
      if (source === 'calendarInput') {
        if (this.name === 'enableDaySelection') {
          this.expiryDate = this.parseCalendarInputValue(value);
        }
      }

      if (source === 'enableDaySelection') {
        this.enableDaySelection = value as boolean;
        const currentValue = this.calendarInputValue;
        if (currentValue) {
          const calendarElement = this.calendarInputElement.nativeElement;
          const value = this.enableDaySelection
            ? `${currentValue}-${getLastDayOfMonth(currentValue)}`
            : currentValue.substring(0, 7);
          this.calendarInputValue = value;
          calendarElement.value = value;
          const timerSubsctiption = timer(100).subscribe(() => {
            calendarElement.dispatchEvent(new Event('change'));
            timerSubsctiption.unsubscribe();
          });
          this.expiryDate = value;
          this.changeDetectorRef.detectChanges();
        }
      }
    }
  }

  showCalendar(event: Event, element: HTMLInputElement) {
    event.preventDefault();
    event.stopImmediatePropagation();
    // if(placeholder)
    //   return this.component.nativeElement.setFocus();
    if ('showPicker' in element) {
      element.showPicker();
    }
  }

  handleCalendarPick(value: string) {
    if (value) {
      this.calendarInputValue = value;
      this.value = value;
      // this.value = this.parseCalendarInputValue(value);
      this.changeDetectorRef.detectChanges();
      this.setValue(this.value);
      const subscription = timer(50).subscribe(() => {
        this.calendarInputElement.nativeElement.blur();
        subscription.unsubscribe();
        // nativeElement.parentNode?.dispatchEvent(new CustomEvent('ionBlur'));
      });
      windowEventEmitter(ComponentEventNames.Change, {
        source: 'calendarInput',
        value: this.value,
      });
    }
  }

  parseCalendarInputValue(date: string, revert: boolean = false): string {
    if (revert) {
      return `${formatExpiryDate(date, this.enableDaySelection)}`;
    }
    return convertDateToGS1Format(date);
  }

  revertGS1ToDateValue(date: string): string {
    const year = 2000 + Number(date.slice(0, 2));
    const month = Number(date.slice(2, 4));
    if (!this.enableDaySelection) return `${year}-${month}`;
    let day = Number(date.slice(4, 6));
    day = day === 0 ? Number(getLastDayOfMonth(`${year}-${month}`)) : day;
    return `${year}-${month}-${day < 10 ? '0' + day : day}`;
  }
}
